var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('sort-definition-nested',{attrs:{"items":_vm.sortDefinition,"hide-templates":_vm.hideTemplates},on:{"move":_vm.move,"entrySave":function($event){return _vm.$emit("entrySave")},"save":_vm.save}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }